/** Card grid layout for persona opportunity sets (matches legacy opportunities spacing). */
export const PERSONA_OPPORTUNITY_SET_GRID_CLASS =
  "grid grid-cols-1 gap-4 overflow-x-visible sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-3 2xl:grid-cols-4";
